// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useState } from "react";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";
import { useGetProperties } from "../../hooks/useGetProperties";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
import Pagination from "../Properties/Pagination";
import ImmobiliList from "../Properties/ImmobiliList";


// CONFIGURAZIONI
import appConfig, { AGENCY_ID } from "../../config/appConfig";
import { WidgetMail } from "../Widgets/WidgetMail/WidgetMail";

const Luxury: React.FC = () => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(AGENCY_ID);

    const { properties, totalCount,loading, error } = useGetProperties(AGENCY_ID, {
        limit: 10000,
        offset: 0,
        withCount: false,
        status: [2,3,9,11],
        filters: {
            luxury: false,
            contract: [],
            type: [1,2,5,6,10,15,16,18,39],
            minPrice: 600000,
        },
        orderBy: {
            field: 'insertionDate',
            direction: 'desc',
        },
        portal: 56
    })

    const [currentPage, setCurrentPage] = useState(1);
    const [propertiesPerPage] = useState(5);
    const totalPages = totalCount > 0 ? Math.ceil(totalCount / propertiesPerPage) : Math.ceil(properties.length / propertiesPerPage);
    const startIndex = (currentPage - 1) * propertiesPerPage;
    const currentProperties = properties.slice(startIndex, startIndex + propertiesPerPage)
    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            window.scrollTo(0, 0);
        }
    };

// Rendering
if (agencyLoading) return <LoadingIndicator />;
if (agencyError) return <ServerError />;

return (
    <>
        <Helmet>
            <title>{t('luxuryPage.metaTitle')}</title>
            <meta name="description" content={t('luxuryPage.metaDescription') as string }/>
        </Helmet>

        <SubHeaderDefault title={t('luxuryPage.pageTitle')} isSeo={true} />

        <main id="page" className="luxury-page">
            <div className="container-fluid">
                <section className="space-ptb">
                    <h2 className="mb-5">{t('luxuryPage.title')}</h2>
                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('luxuryPage.paragraph') as string }}></p>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8">

                            <ImmobiliList 
                                properties={currentProperties}
                                loading={loading}
                                error={null}
                                basePath="immobile"
                                labelSold={false}
                            />

                            {/* Paginazione */}
                            {totalCount > propertiesPerPage && !error && (
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <Pagination
                                            count={totalCount || 0}
                                            limit={propertiesPerPage}
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="mb-4">
                                <WidgetContacts
                                    agencyDataAddress={agency?.address_details?.address ?? ''}
                                    agencyDataCity={agency?.address_details?.city_name ?? ''}
                                    agencyDataComuneCapoluogo={agency?.address_details?.city_name === agency?.address_details?.province_name}
                                    agencyDataProvinciaSigla={agency?.address_details?.sigla ?? ''}
                                    agencyDataEmail={appConfig.agency.agencyEmail}
                                    agencyDataEmailShow={appConfig.ui.agencyWidget.showEmail}
                                    agencyDataPhone1={agency?.phone1 ?? ''}
                                    agencyDataPhone2={agency?.phone2 ?? ''}
                                    agencyDataInternationalPrefix={appConfig.agency.intlPrefix ?? '+39'}
                                    agencyDataMobile={agency?.mobile ?? ''}
                                    agencyDataMobile2={agency?.mobile2 ?? ''}
                                    agencyDataFax={agency?.fax ?? ''}
                                    agencySocialShow={appConfig.ui.agencyWidget.showSocialLinks}
                                    agencyDataWhatsapp={appConfig.socialLinks.whatsapp}
                                    agencyDataFacebook={appConfig.socialLinks.facebook}
                                    agencyDataInstagram={appConfig.socialLinks.instagram}
                                    agencyDataTwitter={appConfig.socialLinks.twitter}
                                    agencyDataLinkedin={appConfig.socialLinks.linkedin}
                                    agencyDataPinterest={appConfig.socialLinks.pinterest}
                                    agencyDataYoutube={appConfig.socialLinks.youtube}
                                />
                            </div>
                            <WidgetMail />

                        </div>
                    </div>
                </section>
            </div>
        </main>
    </>
);
};

export default Luxury;
